import 'assets/scripts/sentry.js';
import 'assets/styles/login.scss';
import 'bootstrap';
import 'jquery-toast-plugin';
import {
	loadEnLocaleFlag,
} from 'assets/scripts/language-toggle-flags.js';

const loadedComponents = [];

document.addEventListener( 'DOMContentLoaded', async () => {
	loadEnLocaleFlag();

	/**
	 * Bootstrap the components
	 */
	for ( const dataComponent of document.querySelectorAll( '[data-component]' ) ) {
		const componentName = dataComponent.dataset.component;

		if ( loadedComponents.indexOf( componentName ) === -1 ) {
			loadedComponents.push( componentName );

			try {
				const component = await import(
					/* WebpackMode: "lazy" */
					/* WebpackPrefetch: true */
					/* WebpackPreload: true */
					`components/${componentName}/${componentName}.js`
				);

				component.default();
			} catch ( error ) {
				// eslint-disable-next-line no-console
				console.error( 'Loading error: ', error );
			}
		}
	}
} );
